import { Navigate } from 'react-router-dom';

export default function DashboardPage() {
  return <Navigate to="/dashboard/alertas-kpis" replace />;
}
